
import  React,{useEffect} from "react"
import {createPortal} from "react-dom"

const modalRoot = document.getElementById("modal-root");

if (!modalRoot) {
    throw new Error("modal-root element is missing in the DOM");
}

const UiModal = ({isOpen, children}) => {
    // Prevent background scroll when modal is open
    useEffect(() => {
        if (!isOpen) {
            document.body.style.overflow = "";
        } else {
            document.body.style.overflow = "hidden";
        }
    }, [isOpen]);

    if (!isOpen) return null;
    return createPortal(
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10000,
            }}
        >
            {children}
        </div>,
        modalRoot
    );
};

export default UiModal;